import { useEffect, useRef } from 'react';

const usePullToRefresh = (onRefresh, threshold = 70) => {
  const startYRef = useRef(null);
  const triggeredRef = useRef(false);

  useEffect(() => {
    const handleTouchStart = (event) => {
      if (window.scrollY > 0) return;
      startYRef.current = event.touches[0].clientY;
      triggeredRef.current = false;
    };

    const handleTouchMove = (event) => {
      if (startYRef.current === null) return;
      const currentY = event.touches[0].clientY;
      const distance = currentY - startYRef.current;
      if (distance > threshold && !triggeredRef.current) {
        triggeredRef.current = true;
        onRefresh();
        if (navigator?.vibrate) {
          navigator.vibrate(10);
        }
      }
    };

    const handleTouchEnd = () => {
      startYRef.current = null;
      triggeredRef.current = false;
    };

    window.addEventListener('touchstart', handleTouchStart, { passive: true });
    window.addEventListener('touchmove', handleTouchMove, { passive: true });
    window.addEventListener('touchend', handleTouchEnd);

    return () => {
      window.removeEventListener('touchstart', handleTouchStart);
      window.removeEventListener('touchmove', handleTouchMove);
      window.removeEventListener('touchend', handleTouchEnd);
    };
  }, [onRefresh, threshold]);
};

export default usePullToRefresh;
